import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Separator } from '@wartek-id/separator'
import { Icon } from '@wartek-id/icon-v2'

interface VerticalProgressItemProps extends React.HTMLProps<HTMLDivElement> {
  step?: number | string
  isActive?: boolean
  isDone?: boolean
  isFailed?: boolean
  withVerticalLine?: boolean
}

const VerticalProgressItem = ({
  step = '',
  isActive = false,
  isDone = false,
  isFailed = false,
  withVerticalLine = false,
  children,
  className,
  ...otherProps
}: VerticalProgressItemProps) => {
  return (
    <div className={clsx('flex gap-4 pb-4', className)} {...otherProps}>
      <div>
        <div
          className={clsx(
            'w-6 h-6 rounded-full border border-subdued flex justify-center items-center',
            {
              'bg-primary': !isFailed && !isDone && isActive,
              'bg-surface-subdued': !isActive,
            }
          )}
        >
          {isFailed ? (
            <Icon className="!text-subdued !text-lg !leading-none !size-[18px]">
              close
            </Icon>
          ) : isDone ? (
            <Icon className="!text-subdued !text-lg !leading-none !size-[18px]">
              check
            </Icon>
          ) : (
            <Text variant="helper" color={isActive ? 'inverse' : 'subdued'}>
              {step}
            </Text>
          )}
        </div>
        {withVerticalLine && (
          <div className="h-full flex justify-around content-center pt-3 pb-6">
            <Separator orientation="vertical" />
          </div>
        )}
      </div>

      <div className="p-3 w-full bg-white rounded border border-subdued">
        {children}
      </div>
    </div>
  )
}

export default VerticalProgressItem
